<div *ngIf="currentGroup?.type !== GroupType.Hcp || currentGroup === undefined">
  <h2 class="text-navy text-base break-words" mat-dialog-title>
    {{ 'kimbo-home.download-app-title' | translate }}
  </h2>
  <button
    class="close-button"
    color="primary"
    mat-dialog-close
    mat-button
    aria-label="Example icon button with a delete icon">
    <mat-icon>close</mat-icon>
  </button>
  <mat-dialog-content class="flex flex-col justify-center items-center gap-3">
    <div class="flex flex-col mt-5 gap-3">
      <div
        *ngIf="data?.caller === '_LOGIN'"
        class="p-4 w-full bg-kimbo-blue text-kimbo-blue bg-opacity-10 rounded-sm justify-center items-center"
        [innerHTML]="'kimbo-home.hcp-notice-msg' | translate"></div>
      <p>{{ 'kimbo-home.download-app-msg' | translate }}</p>
      <p [innerHTML]="'kimbo-home.qrcode-scan-msg' | translate"></p>
    </div>
    <div
      class="p-4 w-[300px] h-[300px] rounded-full bg-center bg-cover shrink-0"
      [ngStyle]="{
        'background-image': 'url(' + qrcodeImg + ')'
      }"></div>
  </mat-dialog-content>
</div>
<!--div *ngIf="currentGroup?.type !== GroupType.Kimbo">
  <h2 class="text-navy text-base break-words" mat-dialog-title>
    {{ 'kimbo-layout.migration-notice-heading' | translate }}
  </h2>
  <mat-dialog-content class="flex flex-col gap-3">
    <div class="flex flex-col mt-5 gap-3">
      <span> {{ 'kimbo-layout.dear-user' | translate }}</span>
      <p [innerHTML]="'kimbo-layout.new-version-msg' | translate"></p>
    </div>

    <div class="flex gap-2 mb-2 font-bold text-kimbo-blue">
      {{
        'kimbo-layout.migration-date-msg' | translate : { date: migrationDate }
      }}
    </div>

    <div class="flex flex-col gap-2 p-4 bg-kimbo-blue bg-opacity-10 rounded-sm">
      <span class="font-medium">{{
        'kimbo-layout.precaution-section-title' | translate
      }}</span>
      <ul class="list-disc ml-6">
        <li
          [innerHTML]="
            'kimbo-layout.precaution-action-one'
              | translate : { date: blocageDate }
          "></li>
        <li [innerHTML]="'kimbo-layout.precaution-action-two' | translate"></li>
        <li
          [innerHTML]="'kimbo-layout.precaution-action-three' | translate"></li>
      </ul>
    </div>

    <div *ngIf="articleLink" class="flex gap-2">
      <span>{{ 'kimbo-layout.article-notice' | translate }}</span>
      <a
        [href]="articleLink"
        target="_blank"
        class="text-kimbo-blue hover:underline">
        {{ 'kimbo-layout.read-article' | translate }}
      </a>
    </div>

    <div>
      {{ 'kimbo-layout.thanks-msg' | translate }}
    </div>
    <div *ngIf="!data" class="flex justify-center items-center">
      <app-spinner class="inline-block h-12 w-12 filter-blue"></app-spinner>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="w-full my-4 flex justify-center items-center">
      <button
        class="h-12 w-fit p-2"
        mat-raised-button
        color="primary"
        type="button"
        (click)="close()">
        <span>{{ 'kimbo-layout.understood' | translate }}</span>
      </button>
    </div>
  </mat-dialog-actions>
</!--div-->
